export default __webpack_public_path__ + "static/media/about-me.0d516126.png";